// The avatar initial (customer design bd-core.js `P.initials`, e.g. "রু"): the first
// user-perceived character of the name, cased for the UI language. A Bangla name's
// first letter carries its vowel sign ("রু", not a bare "র"), so the name is split
// into grapheme clusters (Intl.Segmenter) rather than UTF-16 units.
export function nameInitial(name: string | null | undefined, lang: string): string {
  const trimmed = (name ?? '').trim();
  if (!trimmed) return '';
  const first =
    typeof Intl.Segmenter === 'function'
      ? (new Intl.Segmenter(lang, { granularity: 'grapheme' }).segment(trimmed)[Symbol.iterator]().next().value?.segment ?? '')
      : trimmed.charAt(0);
  return first.toLocaleUpperCase(lang);
}
